import s from './List.scss'
import MaterialTable from '@material-table/core'

const columns = [
  { title: 'Name', field: 'userName', defaultSort: 'asc' },
  { title: 'Email', field: 'email' },
  {
    title: 'Role(s)',
    field: 'roles',
    render: row =>
      row.roles
        .filter(role => role.includes('ROLE_TIMETRACKER'))
        .map(role => {
          switch (role) {
            case 'ROLE_TIMETRACKER_ADMIN':
              return 'Time Tracker Admin'
            case 'ROLE_TIMETRACKER':
              return 'Time Tracker User'
            default:
              return ''
          }
        })
        .join(', ')
  }
]

const List = ({ users, removeUser, openEditUser }) => {
  return (
    <div className={s.listWrapper}>
      <MaterialTable
        title="Current Users:"
        columns={columns}
        data={users}
        options={{
          actionsColumnIndex: -1,
          sorting: true,
          headerStyle: {
            backgroundColor: '#eee',
            color: '#000',
            position: 'sticky',
            top: 0,
            zIndex: 1,
            fontSize: '14px'
          },
          maxBodyHeight: '400px',
          pageSize: 20,
          padding: 'dense'
        }}
        style={{
          boxShadow: 'none',
          fontSize: '14px'
        }}
        actions={[
          () => ({
            icon: 'edit',
            tooltip: 'Edit User',
            onClick: (event, rowData) => openEditUser(rowData)
          }),
          () => ({
            icon: 'delete',
            tooltip: 'Delete User',
            onClick: (event, rowData) => removeUser(rowData)
          })
        ]}
      />
    </div>
  )
}

export default List
